import { Koi } from '@ksyos/koi';
import type { ProcessActivityAsset } from '@common/validation/processActivityAsset';
import { getProcessActivityAssetsSchema } from '@common/validation/processActivityAsset';

export type OsasMraLetterCustomControlData = {
    assets: ProcessActivityAsset[];
};

export const osasMraLetterSchema = Koi.object({
    assets: getProcessActivityAssetsSchema({ max: 20 }),
});
